/* hush-glow: comportamento das secoes copiadas (o scope remove os <script> do concorrente) */
(function () {
  // toca direto (o concorrente tambem: t>0 poucos segundos apos o load)
  var started = true;
  // escolhe a fonte desktop/mobile do video; o poster aparece ate a primeira interacao
  function pickVideos() {
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    document.querySelectorAll('video[data-src-desktop], video[data-src-mobile]').forEach(function (v) {
      var d = v.dataset;
      var src = mobile ? (d.srcMobile || d.srcDesktop) : (d.srcDesktop || d.srcMobile);
      var poster = mobile ? (d.posterMobile || d.posterDesktop) : (d.posterDesktop || d.posterMobile);
      if (poster && v.getAttribute('poster') !== poster) v.setAttribute('poster', poster);
      v.muted = true; v.loop = true; v.playsInline = true;
      if (src && v.getAttribute('src') !== src) {
        v.setAttribute('preload', 'auto');
        v.src = src;
      }
      if (started && v.paused) play(v);
    });
  }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function start() {
    if (started) return; started = true;
    document.querySelectorAll('video[data-src-desktop], video[data-src-mobile]').forEach(play);
  }
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
    window.addEventListener(ev, start, { once: true, passive: true });
  });
  document.addEventListener('DOMContentLoaded', pickVideos);
  window.addEventListener('resize', pickVideos);
  if (document.readyState !== 'loading') pickVideos();
})();

/* abas copiadas (eg-upsell etc.): [role=tab][data-tab=N] alterna o painel [data-panel=N] irmao */
document.addEventListener('click', function (e) {
  var tab = e.target.closest && e.target.closest('[role="tab"][data-tab]');
  if (!tab) return;
  var list = tab.closest('[role="tablist"]'); if (!list) return;
  var box = list.parentElement, n = tab.getAttribute('data-tab');
  list.querySelectorAll('[role="tab"][data-tab]').forEach(function (t) {
    var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false');
  });
  box.querySelectorAll('[data-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === n); });
});

/* descricao do tom sob os swatches (mapa por pagina em window.__clShadeDesc) */
(function () {
  function paint() {
    var map = window.__clShadeDesc; if (!map) return;
    document.querySelectorAll('variant-selects .color-swatches-container, variant-radios .color-swatches-container').forEach(function (c) {
      var inp = c.querySelector('input[type=radio]:checked'); if (!inp || !map[inp.value]) return;
      var d = c.nextElementSibling && c.nextElementSibling.classList.contains('shade-description') ? c.nextElementSibling : null;
      if (!d) { d = document.createElement('div'); d.className = 'shade-description'; c.parentNode.insertBefore(d, c.nextSibling); }
      d.innerHTML = '<span class="shade-description__name"></span> <span class="shade-description__text"></span>';
      d.children[0].textContent = inp.value; d.children[1].textContent = map[inp.value];
    });
  }
  document.addEventListener('DOMContentLoaded', paint);
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('.color-swatch input')) setTimeout(paint, 0); });
  if (document.readyState !== 'loading') setTimeout(paint, 0);
})();

/* rotulo por opcao do seletor de variantes (o 1.3.0 so tem um template de rotulo para todas) */
(function () {
  function paint() {
    var labels = window.__clOptionLabels; if (!labels) return;
    document.querySelectorAll('variant-selects, variant-radios').forEach(function (vs) {
      vs.querySelectorAll('[id^="custom-label-"]').forEach(function (el) {
        var n = parseInt(el.id.split('-').pop(), 10);
        if (labels[n - 1]) el.textContent = labels[n - 1];
      });
    });
  }
  document.addEventListener('DOMContentLoaded', paint);
  document.addEventListener('change', function () { setTimeout(paint, 0); setTimeout(paint, 900); });
  if (document.readyState !== 'loading') setTimeout(paint, 0);
})();

/* feed Instagram (Elfsight) copiado: o widget nao vem junto. Pagina por seta, por arraste do
   mouse e por swipe de toque; volta ao inicio depois da ultima pagina (o dele faz loop). */
(function () {
  function setup(root) {
    if (root.__clIg) return; root.__clIg = true;
    var inner = root.querySelector('.eui-slider-inner'); if (!inner) return;
    var views = inner.querySelectorAll(':scope > .eui-slider-slide'); var n = views.length;
    var box = root.parentElement;
    var prev = box.querySelector('.eui-slider-arrow-prev'), next = box.querySelector('.eui-slider-arrow-next');
    var i = 0;
    inner.style.transitionDuration = '0ms';
    function go(k, anim) {
      i = (k + n) % n;
      inner.style.transitionDuration = anim === false ? '0ms' : '400ms';
      inner.style.transform = 'translate3d(' + (-100 * i) + '%, 0px, 0px)';
      views.forEach(function (v, j) { v.classList.toggle('eui-slider-slide-active', j === i); if (j === i) v.removeAttribute('inert'); else v.setAttribute('inert', ''); });
      if (prev) prev.classList.toggle('eui-slider-arrow-enabled', i > 0);
      if (next) next.classList.toggle('eui-slider-arrow-enabled', n > 1);
    }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(i - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(i + 1); });
    // arraste (mouse) e swipe (toque): o trilho acompanha o dedo; passou de 15% troca de pagina
    var x0 = null, y0 = 0, dx = 0, horiz = null, moved = false;
    function down(x, y) { x0 = x; y0 = y; dx = 0; horiz = null; moved = false; inner.style.transitionDuration = '0ms'; }
    function move(x, y, ev) {
      if (x0 === null) return;
      dx = x - x0; var dy = y - y0;
      if (horiz === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) horiz = Math.abs(dx) > Math.abs(dy);
      if (!horiz) return;
      moved = true; if (ev.cancelable) ev.preventDefault();
      inner.style.transform = 'translate3d(calc(' + (-100 * i) + '% + ' + dx + 'px), 0px, 0px)';
    }
    function up() {
      if (x0 === null) return; x0 = null;
      if (!horiz) return;
      var w = root.clientWidth || 1;
      if (dx < -w * 0.15) go(i + 1); else if (dx > w * 0.15) go(i - 1); else go(i);
    }
    root.addEventListener('touchstart', function (e) { var t = e.touches[0]; down(t.clientX, t.clientY); }, { passive: true });
    root.addEventListener('touchmove', function (e) { var t = e.touches[0]; move(t.clientX, t.clientY, e); }, { passive: false });
    root.addEventListener('touchend', up); root.addEventListener('touchcancel', up);
    root.addEventListener('mousedown', function (e) { if (e.button === 0) { e.preventDefault(); down(e.clientX, e.clientY); } });
    window.addEventListener('mousemove', function (e) { move(e.clientX, e.clientY, e); });
    window.addEventListener('mouseup', up);
    // o clique que encerra um arraste nao abre o post
    root.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    root.addEventListener('dragstart', function (e) { e.preventDefault(); });
    go(0, false);
  }
  function init() { document.querySelectorAll('.eapps-instagram-feed-posts-slider.eui-slider').forEach(setup); }
  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
  document.addEventListener('shopify:section:load', init);
})();

/* rede de seguranca: splide-component copiado que o tema nao montou (ex.: seção recarregada
   no editor) ganha uma instancia com as opcoes dos data-attrs — arraste/swipe sempre ativos */
(function () {
  function mount() {
    if (!window.Splide) return;
    document.querySelectorAll('[class*="cl-sec-"] splide-component').forEach(function (c) {
      var el = c.querySelector('.splide');
      if (!el || el.classList.contains('is-initialized') || el.__clSplide) return;
      var d = c.dataset, mob = window.matchMedia('(max-width: 749px)').matches;
      try {
        el.__clSplide = new window.Splide(el, {
          type: d.type || 'slide', perPage: +(mob ? d.slidesMobile : d.slidesDesktop) || 1,
          perMove: +(mob ? d.perMoveMobile : d.perMoveDesktop) || 1, gap: (mob ? d.gapMobile : d.gapDesktop || 0) + 'px',
          drag: true, arrows: true, pagination: true
        }).mount();
      } catch (e) {}
    });
  }
  window.addEventListener('load', function () { setTimeout(mount, 1500); });
})();

/* CTAs copiados ("TRY NOW", "MIX & MATCH"...) apontam para a ancora da secao main-product DO
   CONCORRENTE (#shopify-section-template--<id dele>__main, renomeada pelo scope). Qualquer ancora
   para "...__main" rola suave ate o main-product desta pagina; ancora para outra secao dele
   ("...__<sufixo>") vai para a NOSSA secao de mesmo sufixo; reviews ausentes -> bloco de reviews. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href*="#"]');
  if (!a) return;
  var href = a.getAttribute('href') || '';
  if (href.charAt(0) !== '#' && href.split('#')[0] !== location.pathname) return;
  var hash = href.split('#')[1] || '';
  if (!hash || document.getElementById(hash)) return;   // ancora existe de verdade: comportamento normal
  var main = document.querySelector('[id^="shopify-section-"][id$="__main"]') || document.querySelector('product-info');
  var target = null;
  if (/__main$|^MainProduct|^ProductInfo-|^product-info/i.test(hash)) target = main;
  else if (/^(cl-)?shopify-section-.+__(.+)$/.test(hash)) {
    var suf = hash.split('__').pop();
    target = document.querySelector('[id^="shopify-section-"][id$="__' + CSS.escape(suf) + '"]');
    if (!target && /testimonial/i.test(hash))
      target = document.querySelector('[id^="shopify-section-"][id*="testimonial" i]');
    if (!target && /1751831758d7faaacf|review|testimonial/i.test(hash))
      target = document.querySelector('#pdp-custom-reviews, .product__info-container [class*="review"], [id*="review" i]');
  }
  if (!target) return;
  main = target;
  e.preventDefault();
  var hdr = document.querySelector('.section-header, sticky-header');
  var off = hdr ? hdr.getBoundingClientRect().height : 0;
  window.scrollTo({ top: main.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
}, true);

/* upsell nativo: no Shrine 1.3.3 do concorrente o CARD inteiro alterna a selecao; no 1.3.0 so o
   botao (.upsell-toggle-btn). Clique no card fora do seletor de variante aciona o botao. */
document.addEventListener('click', function (e) {
  var t = e.target;
  if (!t.closest) return;
  var card = t.closest('product-info-upsell .upsell__container');
  if (!card || t.closest('.upsell-toggle-btn, select, option, a, .upsell__variant-picker')) return;
  var btn = card.closest('product-info-upsell').querySelector('.upsell-toggle-btn');
  if (btn && !card.classList.contains('upsell-toggle-btn')) btn.click();
});

/* depoimentos eg-testimonials: "Read More"/"Read Less" (o <script> inline da secao dele cai no scope).
   Botao some quando o texto cabe no clamp, como no original. */
(function () {
  function sync() {
    document.querySelectorAll('[data-eg-tm-toggle]').forEach(function (btn) {
      var t = btn.previousElementSibling;
      if (!t || !t.hasAttribute('data-eg-tm-text')) return;
      btn.hidden = !t.classList.contains('is-expanded') && !(t.scrollHeight - t.clientHeight > 2);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-eg-tm-toggle]');
    if (!btn) return;
    var t = btn.previousElementSibling; if (!t) return;
    var on = t.classList.toggle('is-expanded');
    btn.textContent = on ? (btn.dataset.less || 'Read Less') : (btn.dataset.more || 'Read More');
  });
  requestAnimationFrame(function () { requestAnimationFrame(sync); });
  window.addEventListener('load', sync);
  window.addEventListener('resize', sync);
})();
